import { render, staticRenderFns } from "./reportList.vue?vue&type=template&id=1f74d53c&"
import script from "./reportList.vue?vue&type=script&lang=js&"
export * from "./reportList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports